/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './equipment-allotment.reducer';

export const EquipmentAllotmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const equipmentAllotmentEntity = useAppSelector(state => state.equipmentAllotment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="equipmentAllotmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.equipmentAllotment.detail.title">EquipmentAllotment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.id">Id</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.id}</dd>
          <dt>
            <span id="allotmentDate">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.allotmentDate">Allotment Date</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.allotmentDate}</dd>
          <dt>
            <span id="releaseDate">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.releaseDate">Release Date</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.releaseDate}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.active">Active</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="allotmentNotes">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.allotmentNotes">Allotment Notes</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.allotmentNotes}</dd>
          <dt>
            <span id="allottedById">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.allottedById">Allotted By Id</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.allottedById}</dd>
          <dt>
            <span id="releasedById">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.releasedById">Released By Id</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.releasedById}</dd>
          <dt>
            <span id="allottedByType">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.allottedByType">Allotted By Type</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.allottedByType}</dd>
          <dt>
            <span id="releasedByType">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.releasedByType">Released By Type</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.releasedByType}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.quantity}</dd>
          <dt>
            <span id="allotmentType">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.allotmentType">Allotment Type</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentEntity.allotmentType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentAllotment.admission">Admission</Translate>
          </dt>
          <dd>{equipmentAllotmentEntity.admission ? equipmentAllotmentEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentAllotment.equipment">Equipment</Translate>
          </dt>
          <dd>{equipmentAllotmentEntity.equipment ? equipmentAllotmentEntity.equipment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentAllotment.appointment">Appointment</Translate>
          </dt>
          <dd>{equipmentAllotmentEntity.appointment ? equipmentAllotmentEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentAllotment.equipmentCharge">Equipment Charge</Translate>
          </dt>
          <dd>{equipmentAllotmentEntity.equipmentCharge ? equipmentAllotmentEntity.equipmentCharge.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/equipment-allotment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/equipment-allotment/${equipmentAllotmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EquipmentAllotmentDetail;
